<template>
  <main class="track-offer">
    <span>offer type</span>

    <div class="tab-container">
      <div class="tab" @click="clickedType(1)" :class="{ selected:reward.type === null }" data-cy="digital-voucher-tab">
        <span>digital</span>
        <span>voucher</span>
      </div>

      <div class="tab" @click="clickedType(5)" :class="{ selected:reward.type === 'BonusReward' }" data-cy="bonus-points-tab">
        <span>bonus</span>
        <span>points</span>
      </div>

      <div class="tab" @click="clickedType(6)" :class="{ selected:reward.type === 'InstantReward' }" data-cy="instant-points-tab">
        <span>instant</span>
        <span>points</span>
      </div>
    </div>

    <digital-voucher v-if="reward.type === null"
      :payload="reward"
      :preload="preload"
      :loading-preload="loadingPreload"
      :voucher="voucher"
      :loading-voucher="loadingVoucher"
      @update:payload="updateReward"
      @update:preload="updatePreload"
      @update:voucher="updateVoucher"
    />

    <bonus-points v-if="reward.type === 'BonusReward'"
      :payload="reward"
      :preload="preload"
      :loading-preload="loadingPreload"
      @update:payload="updateReward"
      @update:preload="updatePreload"
    />

    <instant-points v-if="reward.type === 'InstantReward'"
      :payload="reward"
      :preload="preload"
      @update:payload="updateReward"
      @update:preload="updatePreload"
    />
  </main>
</template>

<script>
import DigitalVoucher from "./digital-voucher";
import BonusPoints from "./bonus-points";
import InstantPoints from "./instant-points";
import {rewardAPI} from "../../../services/api/rewardAPI";
import {mapGetters} from "vuex";
import {attachmentAPI} from "../../../services/api/attachmentAPI";

export default {
  name: "track-offer",
  components: {InstantPoints, BonusPoints, DigitalVoucher},
  data() {
    return {
      reward: {},
      preload: null,
      loadingPreload: false,
      voucher: null,
      loadingVoucher: false
    }
  },
  async created() {
    this.loadingPreload = true;
    this.loadingVoucher = true;
    await this.refreshRewards();
    await this.refreshAttachments();
    this.loadingPreload = false;
    this.loadingVoucher = false;
  },
  methods: {
    async updateReward(frag) {
      const result = await rewardAPI.patchRewards(this.campaign.reward_id, {
        owner_id: this.campaign.id,
        owner_type: 'Campaign',
        reward: frag
      });

      Object.entries(frag).forEach(([field, value]) => this.$store.commit('VALIDATE_FIELD', { field, value }))

      this.reward = result.reward;
    },
    async updatePreload(file) {
      this.loadingPreload = true;
      if(file === null && this.preload) {
        await attachmentAPI.delete(this.preload.uuid);
      } else {
        await attachmentAPI.create(this.campaign.reward_id,'preload', 'Reward', file);
      }

      await this.refreshAttachments();
      this.loadingPreload = false;
    },
    async updateVoucher(file) {
      this.loadingVoucher = true;
      if(file === null && this.voucher) {
        await attachmentAPI.delete(this.voucher.uuid);
      } else {
        await attachmentAPI.create(this.campaign.reward_id,'coupon', 'Reward', file);
      }

      await this.refreshAttachments();
      this.loadingVoucher = false;
    },
    async refreshAttachments() {
      this.preload = null;
      this.voucher = null;

      if(this.campaign.reward_id !== null) {
        const attachments = await attachmentAPI.forReward(this.campaign.reward_id, this.campaign.id, 'Campaign')
        attachments.forEach((attachment) => {
          if(attachment.label === 'preload') { this.preload = attachment; }
          if(attachment.label === 'coupon') { this.voucher = attachment;}
        });
      }
    },
    async refreshRewards() {
      if(this.campaign.reward_id !== null) {
        const { reward } = await rewardAPI.fetch(this.campaign.reward_id, this.campaign.id, 'Campaign');
        this.reward = reward;
      }

    },
    async clickedType(type) {
      await this.$store.dispatch('UPDATE_CAMPAIGN', { _type: type })
      await this.updateReward({ type: this.rewardType  })
    }
  },

  computed: {
    ...mapGetters(['campaign']),
    rewardType() {
      if(this.campaign.extension_type === 1) {
        return null;
      } else if(this.campaign.extension_type === 5) {
        return 'BonusReward';
      } else if(this.campaign.extension_type === 6) {
        return 'InstantReward';
      }
    }
  }
}
</script>

<style scoped>
.track-offer {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #4a4a4a;
  font-size: 14px;
}

.tab-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom:10px;
  width: 100%;
}

.tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2px 10px;
  line-height: 1;
  width: 100%;
  border: 1px solid #128fff;
  cursor: pointer;
  font-family: 'AileronThin';
}

.tab.selected {
  background-color: #128fff;
  color: white;
}

.tab:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.tab:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
</style>
